export enum BulkEditResource {
    LIGHTING_GROUP = 'LIGHTING_GROUP',
}

export interface BulkEditEvent {
    resource: BulkEditResource;
    ids: string[];
}
